import { getConfig } from "../../config";

function createComparator(properties, locale = null) {

    if (!properties)
        return (a, b) => { return 0; };

    if (typeof properties == 'string')
        properties = [properties];

    if (!locale) {
        const config = getConfig();
        locale = config.locale;
    }

    return (a, b) => {

        for (const prop of properties) {

            const valA = a[prop];
            const valB = b[prop];

            const valAEmpty = (valA === null || valA === undefined);
            const valBEmpty = (valB === null || valB === undefined);

            // Kontrola na null nebo undefined
            if (valAEmpty && valBEmpty) continue; // Obě hodnoty jsou null/undefined, pokračuj
            if (valAEmpty) return -1; // null/undefined je menší
            if (valBEmpty) return 1; // null/undefined je větší

            // Pokud jsou hodnoty řetězce, použij localeCompare s českou lokalizací
            if (typeof valA === 'string' && typeof valB === 'string') {

                const comparison = valA.localeCompare(valB, locale);
                if (comparison !== 0) return comparison;

            } else {

                // Porovnání běžných hodnot
                if (valA < valB) return -1;
                if (valA > valB) return 1;

            }

        }

        return 0; // Pokud jsou všechny vlastnosti stejné

    };

};

function sortCollectionBy(collection, properties, locale = null) {

    if (!collection)
        return collection;
    return collection.sort(createComparator(properties, locale));

};

export {
    createComparator,
    sortCollectionBy,
};